export default {
  users: null,
  editing: null,
  loading: false
}
